<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('orderstate_edit')">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-basket</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-orderstate-show">
      <v-simple-table>
        <template slot="default">
          <thead>
          <tr>
            <th>{{ $t('global.field') }}</th>
            <th>{{ $t('global.value') }}</th>

            <th>{{ $t('global.field') }}</th>
            <th>{{ $t('global.value') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><strong>{{ $t('global.name') }}</strong></td>
            <td>
              {{ item['name'] }}
            </td>
            <td><strong>{{ $t('order.end') }}</strong></td>
            <td :class="colorBoolean(item.end)">
              {{ item['end'] }}
            </td>
          </tr>
          <tr>
            <td><strong>{{ $t('order.cancel') }}</strong></td>
            <td :class="colorBoolean(item.cancel)">
              {{ item['cancel'] }}
            </td>
            <td><strong>{{ $t('order.init') }}</strong></td>
            <td :class="colorBoolean(item.init)">
              {{ item['init'] }}
            </td>
          </tr>

          </tbody>
        </template>
      </v-simple-table>
<br/>
          <h2>
            {{$t('order.couleur_departement')}}
          </h2>
      <v-simple-table>
        <template>
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('order.stateColor') }}</strong></td>
              <td>
                <span :style="{ color:item.couleur }">{{ item['couleur'] }}</span>
              </td>
              <td><strong>{{ $t('order.enAttenteLabo') }}</strong></td>
                <td :class="colorBoolean(item.labo)">
                  {{ item['labo'] }}
                </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td><strong>{{ $t('order.enAttenteCommerciaux') }}</strong></td>
              <td :class="colorBoolean(item.commerciaux)">
                  {{ item['commerciaux'] }}
                </td>
              
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <br/>
      <h2>
        {{$t('order.specialstatus')}}
      </h2>
      <v-simple-table>
        <template>
          <thead>
          <tr>
            <th>{{ $t('global.field') }}</th>
            <th>{{ $t('global.value') }}</th>

            <th>{{ $t('global.field') }}</th>
            <th>{{ $t('global.value') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><strong>{{ $t('order.specialDoable') }}</strong></td>
            <td :class="colorBoolean(item.specialDoable)">
              {{ item['specialDoable'] }}
            </td>
            <td><strong>{{ $t('order.specialOrdered') }}</strong></td>
            <td :class="colorBoolean(item.specialOrdered)">
              {{ item['specialOrdered'] }}
            </td>
          </tr>
          <tr>
            <td><strong>{{ $t('order.specialToPrint') }}</strong></td>
            <td :class="colorBoolean(item.specialToPrint)">
              {{ item['specialToPrint'] }}
            </td>
            <td><strong>{{ $t('order.specialPrinted') }}</strong></td>
            <td :class="colorBoolean(item.specialPrinted)">
              {{ item['specialPrinted'] }}
            </td>
          </tr>

          </tbody>
        </template>
      </v-simple-table>
          <br/>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'OrderState';

export default {
  name: 'OrderStateShow',
  servicePrefix,
  components: {
    Loading,
    Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('orderstate', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('orderstate', ['find'])
  },
  methods: {
    ...mapActions('orderstate', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

    colorBoolean(bool) {
      if (bool) return 'green--text'
      else return 'red--text'
    }
  }
};
</script>
